/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".mat-dialog-content ui-robot-value-editor .ui-grid-table .ui-grid-cell.ui-grid-feature-cell.ui-grid-action-cell{min-width:100px}.mat-dialog-content ui-robot-value-editor .ui-grid-table .ui-grid-expanded-row-container .robot-asset-form-container{padding:20px}.mat-dialog-content ui-robot-value-editor .ui-grid-table .ui-grid-expanded-row-container .robot-asset-form-actions{display:flex;justify-content:flex-end}"];
export { styles as styles };
